export default "__VITE_ASSET__DiGv_VLK__"